import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { ApplicationIssueAddComponent } from './application-issue-add.component'

const APPLICATION_ISSUE_ADD_ROUTES: Routes = [{
    path: '', component: ApplicationIssueAddComponent
}];

export const APPLICATION_ISSUE_ADD_ROUTING  = RouterModule.forChild(APPLICATION_ISSUE_ADD_ROUTES);